import React from 'react';
import Layout from './Layout';
import { Link } from 'react-router-dom'

const WHATSAPP_BENEFICIOS = 'https://wa.me/5217712438160?text=' + encodeURIComponent('Hola, tengo una pregunta sobre mis beneficios por recomendación.');

const PASOS = [
    { icono: 'fas fa-user-friends', texto: 'Recomienda ITMEX a tus amigos, familiares y conocidos.' },
    { icono: 'fas fa-hashtag', texto: 'Asegúrate de que mencionen tu número de servicio al suscribirse.' },
    { icono: 'fas fa-tags', texto: 'Gana $200 MXN en descuentos por cada recomendación desde la primera instalación.' },
];

// Tabla de beneficios: texto oficial, no editar sin el área comercial/legal. `premio` marca los niveles con regalo.
const NIVELES = [
    { recomendados: 1, beneficio: 'Saldo a favor de $200.00 (repartido en 2 mensualidades de $100.00 cada una).' },
    { recomendados: 2, beneficio: 'Saldo a favor de $200.00 (repartido en 2 mensualidades de $100.00 cada una).' },
    { recomendados: 3, beneficio: '1 mes de internet gratis + Taza ITMEX.', premio: true },
    { recomendados: 4, beneficio: 'Saldo a favor de $200.00 (repartido en 2 mensualidades de $100.00 cada una).' },
    { recomendados: 5, beneficio: 'Todas tus recomendaciones valen $300 por un año + 2 meses de internet gratis + Termo ITMEX.', premio: true },
    { recomendados: 6, beneficio: 'Saldo a favor de $300.00 (repartido en 2 mensualidades de $150.00 cada una).' },
    { recomendados: 7, beneficio: 'Saldo a favor de $300.00 (repartido en 2 mensualidades de $150.00 cada una).' },
    { recomendados: 8, beneficio: 'Todas tus recomendaciones valen $400 por un año + Suéter y playera ITMEX.', premio: true },
    { recomendados: 9, beneficio: 'Saldo a favor de $400.00 (repartido en 2 mensualidades de $200.00 cada una).' },
    { recomendados: 10, beneficio: '6 meses de internet gratis + Asistente de voz Alexa. Todas tus recomendaciones valen $300 para siempre.', premio: true },
];

const TERMINOS = [
    {
        titulo: 'Elegibilidad',
        puntos: [
            'Los beneficios aplican solo para clientes actuales de ITMEX que recomienden el servicio a nuevos clientes.',
            'Los nuevos clientes recomendados deben no haber estado suscritos a ITMEX en los últimos 12 meses.',
        ],
    },
    {
        titulo: 'Requisitos de las Recomendaciones',
        puntos: [
            'Cada recomendación debe culminar en la instalación y activación exitosa del servicio.',
            'Los beneficios se aplican a partir del primer mes de activación del servicio del recomendado.',
        ],
    },
    {
        titulo: 'Limitaciones',
        puntos: [
            'Los beneficios no son acumulables con otras promociones o descuentos.',
            'ITMEX puede cambiar o cancelar los beneficios sin previo aviso.',
            'Los beneficios no son canjeables por dinero en efectivo.',
        ],
    },
    {
        titulo: 'Condiciones Generales',
        puntos: [
            'Los términos de los beneficios pueden variar según las políticas internas de ITMEX.',
            'Los clientes deben estar al corriente en sus pagos para ser elegibles para los beneficios.',
        ],
    },
    {
        titulo: 'Consideraciones',
        puntos: [
            <><strong>Periodo de Validación:</strong> Los beneficios se acreditarán dentro de los 30 días siguientes a la activación del servicio del recomendado.</>,
            <><strong>Acceso a Rifa Anual:</strong> Todos los clientes que hayan hecho recomendaciones exitosas tendrán acceso a una rifa anual de gadgets.</>,
            <><strong>Restricciones de Tiempo:</strong> Los beneficios deben ser utilizados dentro de 18 meses desde la fecha de acreditación. Después de 18 meses desde la primera recomendación, se reinician las recomendaciones y el cliente comienza de nuevo con la tabla de beneficios.</>,
            <><strong>Restricciones de Beneficiarios:</strong> Los beneficios no son transferibles; solo el cliente recomendador puede utilizarlos.</>,
        ],
    },
    {
        titulo: 'Cómo Aplicar',
        puntos: [
            'En el día de la instalación del nuevo servicio, el nuevo usuario debe mencionar quién lo recomendó. En ese momento, se documentará la información del recomendador.',
        ],
    },
    {
        titulo: 'Registro de Recomendaciones',
        puntos: [
            'Las recomendaciones deben ser registradas en el sistema de ITMEX en el momento de la instalación del servicio para ser válidas.',
            'Los clientes pueden verificar el estado de sus recomendaciones llamando al centro de atención al cliente.',
        ],
    },
    {
        titulo: 'Proceso a seguir en caso de que se aplique un descuento a un usuario que tiene saldo a favor',
        puntos: [
            'Cuando se aplique el descuento y junto con el saldo a favor el resultado de la cuenta sea CERO, se debe cambiar el estado de la factura a pagada para evitar que se corte el servicio. Ya que la forma de realizar cortes se basa en las facturas pendientes del mes en curso.',
        ],
    },
];


class Beneficios extends React.Component {
    state = { terminosAbiertos: false };

    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }

    render() {
        const { terminosAbiertos } = this.state;
        return (
            <div>
                <Layout title="Red Itmex - Beneficios">

                    <section className="beneficiosItmex">
                        <div className="planesItmex-header">
                            <span className="planesItmex-eyebrow">Beneficios Itmex</span>
                            <h1 className="tituloItmex">Recomienda Itmex<br />y gana descuentos</h1>
                            <p className="planesItmex-subtitulo">$200 MXN por cada recomendación, más premios conforme sumas recomendados.</p>
                        </div>

                        <h2 className="promosItmex-grupo-titulo"><i className="fas fa-route"></i>¿Cómo funciona?</h2>
                        <ol className="beneficiosPasos">
                            {PASOS.map((paso, i) => (
                                <li key={i} className="beneficiosPaso">
                                    <span className="beneficiosPaso-numero">{i + 1}</span>
                                    <span className="beneficiosPaso-icono"><i className={paso.icono}></i></span>
                                    <p>{paso.texto}</p>
                                </li>
                            ))}
                        </ol>
                        <p className="beneficiosNota">
                            Gana descuentos aplicables a tu servicio de internet. Cuantas más personas recomiendes, más descuentos acumulas. Entre más recomiendes, podrás adquirir premios exclusivos. ¡Permanece atento para descubrir todas las sorpresas que ITMEX tiene preparadas para ti!
                        </p>

                        <h2 className="promosItmex-grupo-titulo beneficiosTitulo-tabla"><i className="fas fa-gift"></i>Tabla de beneficios</h2>
                        <div className="beneficiosTabla" role="table" aria-label="Tabla de beneficios">
                            <div className="beneficiosTabla-encabezado" role="row">
                                <span role="columnheader"><span className="d-none d-sm-inline">Recomendados</span><span className="d-sm-none" aria-label="Recomendados">#</span></span>
                                <span role="columnheader">Beneficios</span>
                            </div>
                            {NIVELES.map(nivel => (
                                <div key={nivel.recomendados} role="row" className={'beneficiosNivel' + (nivel.premio ? ' beneficiosNivel--premio' : '')}>
                                    <span role="cell" className="beneficiosNivel-numero">{nivel.recomendados}</span>
                                    <span role="cell" className="beneficiosNivel-texto">
                                        {nivel.beneficio}
                                        {nivel.premio && <span className="beneficiosNivel-badge"><i className="fas fa-gift"></i>Premio</span>}
                                    </span>
                                </div>
                            ))}
                        </div>

                        <div className={'coberturaMunicipio beneficiosTerminos' + (terminosAbiertos ? ' is-abierto' : '')}>
                            <button type="button" className="coberturaMunicipio-header" aria-expanded={terminosAbiertos} onClick={() => this.setState({ terminosAbiertos: !terminosAbiertos })}>
                                <span className="coberturaMunicipio-icono"><i className="fas fa-file-contract"></i></span>
                                <span className="coberturaMunicipio-nombre">
                                    <b>Términos y Condiciones</b>
                                    <span>Elegibilidad, requisitos, limitaciones y vigencia de los beneficios</span>
                                </span>
                                <span className="coberturaMunicipio-toggle"><i className="fas fa-chevron-down"></i></span>
                            </button>
                            <div className="coberturaMunicipio-cuerpo" aria-hidden={!terminosAbiertos}>
                                <div className="coberturaMunicipio-cuerpo-interior">
                                    <div className="beneficiosTerminos-grid">
                                        {TERMINOS.map(seccion => (
                                            <div key={seccion.titulo} className="beneficiosTerminos-seccion">
                                                <h3>{seccion.titulo}</h3>
                                                <ul>
                                                    {seccion.puntos.map((punto, i) => <li key={i}>{punto}</li>)}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <aside className="planesItmex-panel coberturaPanel">
                            <span className="planesItmex-eyebrow">Atención a clientes</span>
                            <h3 className="planesItmex-panel-titulo">¿Tienes preguntas sobre tus beneficios?</h3>
                            <p>Escríbenos para revisar tus recomendaciones registradas y tu saldo a favor.</p>
                            <div className="planesItmex-panel-acciones">
                                <Link className="heroItmex-cta planesItmex-panel-cta" to="/contacto">
                                    Contáctanos
                                    <span className="heroItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
                                </Link>
                                <a className="planesItmex-panel-whatsapp" href={WHATSAPP_BENEFICIOS} target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-whatsapp"></i> WhatsApp
                                </a>
                            </div>
                        </aside>
                    </section>
                </Layout>
            </div>
        )
    }
};
export default Beneficios;
